import { useSyncExternalStore } from 'react';

/**
 * Whether the OS shell is showing a `fullscreen` window right now: the route's
 * variant or a page's runtime override (a game round). Published by `OsShell`
 * for chrome that lives outside the router, such as the Audio Overview bar
 * (ORA-735), which shrinks to a pill over fullscreen windows.
 */
let isFullscreenWindow = false;
const listeners = new Set<() => void>();

export const setOsFullscreenWindow = (value: boolean): void => {
  if (value === isFullscreenWindow) return;
  isFullscreenWindow = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => isFullscreenWindow;

export const useIsOsFullscreenWindow = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);
